<template>
    <div class="az-text">
        <label v-if="labelPadrao" class="label">{{labelPadrao}} {{complementoLabel}}</label>
        <div v-if="text">
        <v-tooltip v-if="text.length > 30" top nudge-top max-width="800">
            <template v-slot:activator="{ on }">
                <div v-on="on">
                    <p v-if="!tabulacao" class="mb-0 text-truncate-multiline texto" :class="[ styles ]">{{ text }}</p>
                    <p v-else class="mb-0 text-truncate-multiline texto tabulacao-content" :class="[ styles ]">{{ text }}</p>
                </div>
            </template>
            <p class="mb-0 text-truncate-multiline" >{{ text }}</p>
        </v-tooltip>
       <div v-else>
           <p v-if="!tabulacao" class="texto">{{ text }}</p>
           <p v-else class="texto tabulacao-content">{{ text }}</p>
       </div>
        </div>
        <a :href="criarLinkDownload(baixar)" v-if="baixar" title="Download do Anexo" target="_blank" class="az-action-link-icon">
            <p class="texto-baixar">Baixar</p>
        </a>
        <p class="mb-0" v-if="!text && !baixar">-</p>
    </div>
</template>

<script>
    export default {
        name: 'CampoApresentacao',
        props: {
            text: {
                type: String,
                required: true
            },
            tela: {
                type: String
            },
            labelPadrao: {
                type: String
            },
            complementoLabel: {
                type: String,
                default: ''
            },
            baixar:{
                type: String
            },
            styles:{
                type: String,
                default: 'max-13'
            },
            tabulacao: {
                type: Boolean,
                default: false
            }
        },
    }
</script>
<style scoped lang="stylus">

    .tabulacao-content
        margin-left 10px

    .label
        font-size 14px
        font-weight bold
        color #3A6861 !important

    .texto
        font-size 14px
        color #777 !important

    .texto-baixar
        font-size 14px
        color #3B73F2 !important
        text-decoration underline

</style>
